<template>
  <div>
    <iframe
      id="bdIframe"
      ref="myIframe"
      height="1000px"
      style="width:100%;"
      :src="src"
      frameborder="0"
      allowtransparency
    ></iframe>
  </div>
</template>

<script>
let _this = null;
export default {
  name: 'Analysis',
  data() {
    return {
      src:
        process.env.VUE_APP_METABASE_URL +
        '/public/dashboard/2554cab9-1706-4044-a603-b9e85c1801e5'
    };
  },
  created() {
    _this = this;
  },
  methods: {
    adaptIframeHeight() {
      console.log(111);
      const oIframe = document.getElementById('bdIframe');
      oIframe.onload = () => {
        try {
          // iframe高度自适应
          let iDoc =
            oIframe.contentDocument ||
            oIframe.document ||
            oIframe.contentWindow;
          let cHeight = Math.max(
            iDoc.body.clientHeight,
            iDoc.documentElement.clientHeight
          );
          let sHeight = Math.max(
            iDoc.body.scrollHeight,
            iDoc.documentElement.scrollHeight
          );
          let height = Math.max(cHeight, sHeight);
          oIframe.style.height = height + 'px';
        } catch (e) {
          oIframe.style.height = '1000px';
        }
      };
    }
  }
};
</script>
